import type {} from '@redux-devtools/extension'; // required for devtools typing
import type { RefObject } from 'react';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { PageState } from '#/shared/types/PageState';

interface PageStateStore {
  pageState: PageState;
  errorCode: number | undefined;
  actionsContainerRef: RefObject<HTMLDivElement | null> | null;
  setActionsContainerRef: (ref: RefObject<HTMLDivElement | null> | null) => void;
  setPageState: (state: PageState, errorCode?: number) => void;
  reset: () => void;
}

export const usePageStateStore = create<PageStateStore>()(
  devtools(
    (set): PageStateStore => ({
      pageState: 'pending',
      errorCode: undefined,
      actionsContainerRef: null,

      setActionsContainerRef: ref => {
        set({ actionsContainerRef: ref }, undefined, 'setActionsContainerRef');
      },

      setPageState: (state, errorCode) => {
        set({ pageState: state, errorCode }, undefined, 'setPageState');
      },

      reset: () => {
        set({ pageState: 'pending', errorCode: undefined, actionsContainerRef: null }, undefined, 'reset');
      },
    }),
    { name: 'page-state-storage' },
  ),
);
